type TabType = {
  tabLogo: string;
  tabTitle: string;
  index: number;
  selectedTab: number;
  setSelectedTab: (index: number) => void;
};

const Tab = ({ tabLogo, tabTitle, index, selectedTab, setSelectedTab }: TabType) => {
  const isCurrentTab = selectedTab === index;
  return (
    <li className="w-1/4 float-left mb-8">
      <button
        className={`flex flex-col w-full h-96 justify-end py-10 ${
          isCurrentTab ? 'border-b-2 border-b-teal-dark' : 'border-b border-b-gray-light'
        }`}
        onClick={() => setSelectedTab(index)}
      >
        <img
          src={tabLogo}
          alt=""
          aria-hidden
          className={`${isCurrentTab ? 'w-48 h-48' : 'w-30 h-30'} mx-auto mb-6`}
        ></img>
        <span className="text-sm mx-auto text-teal-darker flex ">{tabTitle}</span>
      </button>
    </li>
  );
};

export default Tab;
